module.exports = __webpack_public_path__ + "assets/img/基本面.e9eb3f24.png";